import { useTranslation } from "react-i18next";
import { Alert } from "@/components/ui/Alert";

/**
 * Banner shown when the billing status is past_due.
 * Warns the user that their payment has failed.
 */
export function PastDueBanner() {
  const { t } = useTranslation();

  return (
    <Alert variant="warning" className="rounded-xl p-4">
      <span className="text-sm">{t("billing.pastDueBanner")}</span>
    </Alert>
  );
}
